import { ensureVue3DiffWordsDependencies } from "@/helpers/textDiff";

export default {
  name: "TextDiffViewer",
  props: {
    oldText: {
      type: String,
      default: ""
    },
    newText: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      diffApp: null,
      diffState: null,
      hasError: false,
      changeCountTimeoutId: null
    };
  },
  watch: {
    oldText() {
      this.syncDiffState();
    },
    newText() {
      this.syncDiffState();
    }
  },
  mounted() {
    this.mountDiff();
  },
  beforeDestroy() {
    this.unmountDiff();
  },
  methods: {
    async mountDiff() {
      if (this.hasError || !this.$refs.mount) return;

      try {
        const { Vue3, DiffHtml } = await ensureVue3DiffWordsDependencies();
        if (!this.$refs.mount) return;

        this.diffState = Vue3.reactive({
          oldText: this.oldText,
          newText: this.newText,
          options: { ignoreCase: false },
          similarityThreshold: 0.3
        });

        const state = this.diffState;
        this.diffApp = Vue3.createApp({
          name: "TextDiffViewerBridge",
          render() {
            return Vue3.h(DiffHtml, {
              oldText: state.oldText,
              newText: state.newText,
              options: state.options,
              similarityThreshold: state.similarityThreshold,
              ignoreFormattingTags: false
            });
          }
        });

        this.diffApp.mount(this.$refs.mount);
        this.scheduleChangeCountUpdate();
      } catch (error) {
        this.hasError = true;
        this.$emit("change-count", 0);
        this.$emit("error", error);
      }
    },

    syncDiffState() {
      if (!this.diffState) return;
      this.diffState.oldText = this.oldText;
      this.diffState.newText = this.newText;
      this.scheduleChangeCountUpdate();
    },

    scheduleChangeCountUpdate() {
      if (this.changeCountTimeoutId) {
        clearTimeout(this.changeCountTimeoutId);
      }
      this.changeCountTimeoutId = setTimeout(() => {
        this.changeCountTimeoutId = null;
        this.updateChangeCount();
      }, 0);
    },

    updateChangeCount() {
      const mount = this.$refs.mount;
      if (!mount || this.hasError) {
        this.$emit("change-count", 0);
        return;
      }
      const addedCount = mount.querySelectorAll(".diff-added").length;
      const removedCount = mount.querySelectorAll(".diff-removed").length;
      this.$emit("change-count", addedCount + removedCount);
    },

    unmountDiff() {
      if (this.changeCountTimeoutId) {
        clearTimeout(this.changeCountTimeoutId);
        this.changeCountTimeoutId = null;
      }
      if (this.diffApp) {
        this.diffApp.unmount();
        this.diffApp = null;
      }
      this.diffState = null;
      if (this.$refs.mount) {
        this.$refs.mount.innerHTML = "";
      }
    }
  }
};
